import React, { useState, useEffect } from "react";
import Pagination from "../../Reusablecomponents/Pagination";
import ExportButton from "../../Reusablecomponents/ExportButton";
import "../../css/others/Table.css";
import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { apiCall } from "../../main/ApiCall";
import ToastPopup from "../../popups/ToastPopup";
import { ChecklistItem, createToastMessage, ToastMessage } from "../../interFaces/interfaces";
const GlobalTemplates: React.FC = () => {
  const [data, setData] = useState<ChecklistItem[]>([]);
  const [, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectedItems, setSelectedItems] = useState<Set<number>>(new Set());
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const navigate = useNavigate();
  const clientId = localStorage.getItem("clientId");
  const columns = [{ key: "select", label: "Select" }, { key: "serialNumber", label: "S.No" }, { key: "templateName", label: "Checklist Name" }, { key: "description", label: "Description" }, { key: "checklistType", label: "Checklist Type" }, { key: "actions", label: "Actions" }];
  const exportColumns = [{ key: "templateName", label: "Checklist Name" }, { key: "description", label: "Description" }, { key: "checklistType", label: "Checklist Type" }];
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await apiCall("get", "/api/local-templates/base-templates", null, { clientId, page: currentPage - 1, size: itemsPerPage });
        const { content = [], totalElements = 0, totalPages = 0 } = response;
        setData(content);
        setTotalElements(totalElements);
        setTotalPages(totalPages);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [clientId, currentPage, itemsPerPage]);
  const handleCheckboxChange = (localTemplateId: number) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = new Set(prevSelectedItems);
      if (updatedSelectedItems.has(localTemplateId)) {
        updatedSelectedItems.delete(localTemplateId);
      } else {
        updatedSelectedItems.add(localTemplateId);
      }
      return updatedSelectedItems;
    });
  };
  const handleSync = async () => {
    try {
      await apiCall("post", `/api/local-templates/sync?clientId=${clientId}`);
      setMessage(createToastMessage("Sync Completed successfully!", "success", 3000));
      setTimeout(() => window.location.reload(), 3000);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message;
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const handleAddChecklist = async () => {
    if (selectedItems.size === 0) {
      setMessage(createToastMessage("Please select at least one item.", "warning", 3000));
      return;
    }
    const selectedLocalTemplateIds = Array.from(selectedItems).filter(Boolean);
    try {
      await apiCall("patch", "/api/local-templates/add-templates", selectedLocalTemplateIds);
      setMessage(createToastMessage("Checklist(s) added successfully!", "success", 3000));
      setTimeout(() => navigate(-1), 3000);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message;
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const fetchAllDataForExport = async () => {
    try {
      const response = await apiCall("get", "/api/local-templates/base-templates", null, { clientId, page: 0, size: totalElements });
      return (
        response.content?.map((item: ChecklistItem) => ({ templateName: item.templateName || "Empty", description: item.description || "Empty", checklistType: item.isIntegratedChecklist ? "Integrated Checklist" : "Normal Checklist" })) || []
      );
    } catch (error) {
      console.error("Error exporting data:", error);
      return [];
    }
  };
  const handleViewGlobalTemplateDetails = (row: any) => {
    navigate(`/globaltemplatesdetails/${row.localTemplateId}`, {
      state: { isIntegratedChecklist: row.isIntegratedChecklist || false, controls: row.controls || [], },
    });
  };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Global Checklists</h2>
        <div className="table-title-actions">
          <button className="addchecklist" onClick={handleAddChecklist}>Add Checklist</button>
          <button className="sync" onClick={handleSync}>Sync</button>
          <ExportButton data={data.map((row) => ({ templateName: row.templateName || "Empty", description: row.description || "Empty", checklistType: row.isIntegratedChecklist ? "Integrated Checklist" : "Normal Checklist" }))} columns={exportColumns} fetchAllData={fetchAllDataForExport} fileName="global_base_templates" />
        </div>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>
                {columns.map((column) => (
                  <th key={column.key}>{column.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.length > 0 ? (
                data.map((row, index) => (
                  <tr key={row.localTemplateId}>
                    <td>
                      <input type="checkbox" checked={selectedItems.has(row.localTemplateId)} onChange={() => handleCheckboxChange(row.localTemplateId)} />
                    </td>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{row.templateName || "Empty"}</td>
                    <td>{row.description || "Empty"}</td>
                    <td>{row.isIntegratedChecklist ? "Integrated Checklist" : "Normal Checklist"}</td>
                    <td>
                      <FaEye className="action-button" onClick={() => handleViewGlobalTemplateDetails(row)} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="no-data">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
    </div>
  );
};
export default GlobalTemplates;